export const getState = state => state.translation;
export const getData = state => getState(state).data;
export const getLoading = state => getState(state).loading;
export const isLoading = state => getLoading(state).length > 0;
export const getLocale = state => getState(state).locale;
export const isEnabled = state => !!getState(state);
//# sourceMappingURL=selectors.js.map